import { LoggerConfig } from './logger-config';
import { LogLevel } from './enum/log-level';
import { LogMessage } from './model/log-message';
import {AgentLog, ContactLog, SkillLog} from "@nice-ccf/common-sdk";
/**
 * This class implements multiple loglevels with different appenders
 */
export class Logger {
  private static config: LoggerConfig = new LoggerConfig();

  /**
   * Get the module name and class name while create logger object
   *
   * @param module - Module name as an optional
   * @param className - Class name as an optional
   * @example
   * ```
   * const logger = new Logger('module name', class name');
   * ```
   */
  constructor(private module?: string, private className?: string) {}

  /**
   * Set the multiple appenders and log level in Logger
   *
   * @param config - Logger config object
   * @example
   * ```
   * setConfig({appenders:[ConsoleLogAppender], level: 0});
   * ```
   */
  public static setConfig(config: LoggerConfig) {
    Logger.config = config;
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.trace('log info');
   * ```
   */
  public trace(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.doLog(LogLevel.TRACE, { functionName, text:  message, data });
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.info('log info');
   * ```
   */
  public info(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.doLog(LogLevel.INFO, { functionName, text:  message, data });
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.debug('log debug');
   * ```
   */
  public debug(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.doLog(LogLevel.DEBUG, { functionName, text:  message, data });
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.warn('log warn');
   * ```
   */
  public warn(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.doLog(LogLevel.WARN, { functionName, text:  message, data });
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.error('log error');
   * ```
   */
  public error(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.doLog(LogLevel.ERROR, { functionName, text:  message, data });
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.fatal('log fatal');
   * ```
   */
  public fatal(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.doLog(LogLevel.FATAL, { functionName, text:  message, data });
  }

  /**
   *
   * @param level - Log level - 0
   * @param message - Log message
   * @example
   * ```
   * const logMessage: LogMessage
   * doLog(0, logMessage);
   * ```
   */
  private doLog(level: LogLevel, message: LogMessage): void {
    Logger.config.getAppenders().forEach((appender) => {
      appender.append({
        level: level,
        className: this.className,
        module: this.module,
        message: message
      });
    });
  }

}
